export default class Reparto{
    CodiceReparto;
    DescrReparto;
    Note;
    CodiceCompany;

    constructor(){}
}